import React from "react";
import { Service, ServiceOption } from "@/lib/api/types";
import { Button, Divider, Flex, List, Typography } from "antd";
interface ICombineServicesProps {
  services: Service[];
  selectedServices: (Service & { option?: ServiceOption })[];
  showPrice?: boolean;
  onSubmit: (services: any[]) => void;
}
const CombineServices = (props: ICombineServicesProps) => {
  const [selectedServices, setSelectedServices] = React.useState(
    props.selectedServices
  );
  const onAddService = (service: any) => {
    setSelectedServices([...selectedServices, service]);
  };
  const onRemoveService = (service: any) => {
    const indexToRemove = selectedServices.findIndex(
      (selectedService) => selectedService.category === service.category
    );

    if (indexToRemove !== -1) {
      const updatedServices = [...selectedServices];
      updatedServices.splice(indexToRemove, 1);
      setSelectedServices(updatedServices);
    }
  };

  let totalDuration = 0;
  let totalPrices = 0;

  selectedServices.forEach((service) => {
    totalDuration += service.duration;
    totalPrices += service.price;
  });
  return (
    <>
      <List
        itemLayout="horizontal"
        dataSource={props.services}
        renderItem={(item) => {
          let cnt = 0;
          selectedServices.forEach((service) => {
            if (service.category === item.category) cnt++;
          });
          return (
            <List.Item
              actions={[
                <Button key="1" onClick={() => onAddService(item)} size="small">
                  +
                </Button>,
                <Button
                  key="2"
                  onClick={() => onRemoveService(item)}
                  size="small"
                >
                  -
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  <Typography.Text>
                    {item.title}
                    {props.showPrice && item.price && (
                      <>
                        <Divider type="vertical" />${item.price}
                      </>
                    )}
                  </Typography.Text>
                }
                description={item.description}
              />
              <Typography.Text strong>{cnt}</Typography.Text>
            </List.Item>
          );
        }}
      />

      {props.showPrice && (
        <>
          <Divider />
          <Flex justify="space-between">
            <Typography.Title className="m-0" level={5}>
              Total
            </Typography.Title>
            <Typography.Text>${totalPrices}</Typography.Text>
          </Flex>
        </>
      )}

      <Divider />
      <Flex justify="space-between" align="center">
        <Typography.Text strong>Total:</Typography.Text>
        <Typography.Text>{selectedServices.length} service{selectedServices.length > 1 ? "s" : ""}</Typography.Text>
      </Flex>

      <Divider />
      <Button
        disabled={selectedServices.length === 0}
        onClick={() => props.onSubmit(selectedServices)}
        type="primary"
        block
      >
        Find Openings
      </Button>
    </>
  );
};

export default CombineServices;
